import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import ParameterForm from "components/parameters/ParameterForm";
import { updateParameter } from "graphql/mutations";
import {
  equipmentParametersByParameterID,
  getParameter,
} from "graphql/queries";

const ParameterUpdateForm = ({ parameterId, onSuccess }) => {
  const navigate = useNavigate();
  const [parameter, setParameter] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        type,
        description,
        abbreviation,
        unit,
        defaultValue,
        values,
        companies,
      } = valuesParam;

      if (
        type !== parameter.type ||
        (type === "list" &&
          JSON.stringify(values) !== JSON.stringify(parameter.values))
      ) {
        const parametersData = await API.graphql(
          graphqlOperation(equipmentParametersByParameterID, {
            parameterID: parameterId,
            filter: { deletedAt: { attributeExists: false } },
          })
        );
        const parametersItems =
          parametersData.data.equipmentParametersByParameterID.items;

        if (parametersItems.length > 0) {
          toast.error(strings.parameterInUse);
          return;
        }
      }

      await API.graphql({
        query: updateParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            id: parameterId,
            name,
            type,
            description,
            abbreviation,
            unit,
            defaultValue,
            values: JSON.stringify(values),
            companies,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/parameters");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchParameter(id) {
    try {
      const parameterData = await API.graphql(
        graphqlOperation(getParameter, { id })
      );
      const parameterItem = parameterData.data.getParameter;
      if (!parameterItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/parameters");
        return;
      }
      setParameter({
        ...parameterItem,
        values: JSON.parse(parameterItem.values ?? "[]"),
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchParameter(parameterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parameterId]);

  if (!parameter) return <Loader />;

  return (
    <div>
      <ParameterForm
        onSubmit={onSubmit}
        type="update"
        initialValues={parameter}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Parámetro",
    successUpdated: "Parámetro actualizado con éxito",
    parameterInUse:
      "No se puede modificar el tipo y/o los valores porque el parámetro ya está siendo utilizado por un equipo",
    responses: {
      errorFetch: "Error al consultar el parámetro",
    },
  },
});

export default ParameterUpdateForm;
